/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum PriceExplainValueTypeApiModel {
  Price = 'price',

  BaseTax = 'base-tax',

  BaseTaxes = 'base-taxes',

  SalesTax = 'sales-tax',

  SalesTaxes = 'sales-taxes',

  Margin = 'margin',

  Margins = 'margins',

  Option = 'option',

  Options = 'options'
}
